angular.module("vgresiduos").factory("menuService", [
	"featureAccessService",
	function (featureAccessService) {
		"use strict";

		const _organizationHasAccessToState = function (state) {
			return state.isFree || state.isMaster || featureAccessService.hasResiduesManagementModule();
		};

		/**
		 * Calcula showMenuItem e featureAccess de toda a árvore de menu, de baixo para cima.
		 *
		 * - Item folha: usa o próprio getFeatureAccess (Enabled quando não declara nenhum) e o
		 *   check de módulo da organização pode rebaixá-lo para Disabled (cadeado).
		 * - Item com children: parte do acesso mais permissivo entre os filhos. Não é preciso
		 *   repetir no pai o "OU" das regras dos filhos - some sozinho quando todos somem.
		 *   Um getFeatureAccess no pai continua valendo como teto: restringe o pai e, com ele,
		 *   todo o ramo. Use isso apenas para regra que os filhos nao declaram (ex.: modulo).
		 *
		 * O check de modulo (isFree / isMaster / residuesManagement) nao se aplica a itens com
		 * children porque eles nao navegam para lugar nenhum - quem carrega a rota e a folha.
		 */
		const _applyAccess = function (menuRoot) {
			if (!menuRoot || !_hasChildren(menuRoot)) {
				return;
			}

			menuRoot.children.forEach(_resolveAccess);
		};

		function _resolveAccess(menuItem) {
			let access = menuItem.getFeatureAccess ? menuItem.getFeatureAccess() : Vgr.enumerations.userAccess.Enabled;

			if (_hasChildren(menuItem)) {
				access = _mostRestrictive(access, _getAccessFromChildren(menuItem));
			} else if (access == Vgr.enumerations.userAccess.Enabled && !_organizationHasAccessToState(menuItem)) {
				access = Vgr.enumerations.userAccess.Disabled;
			}

			menuItem.featureAccess = access;
			menuItem.showMenuItem = access != Vgr.enumerations.userAccess.Hidden;

			return access;
		}

		function _getAccessFromChildren(menuItem) {
			return menuItem.children.reduce(function (access, child) {
				return _mostPermissive(access, _resolveAccess(child));
			}, Vgr.enumerations.userAccess.Hidden);
		}

		function _hasChildren(menuItem) {
			return Array.isArray(menuItem.children) && menuItem.children.length > 0;
		}

		// Comparacao explicita: o enum userAccess e todo truthy e nao deve ser lido por valor numerico.
		function _restrictiveness(access) {
			switch (access) {
				case Vgr.enumerations.userAccess.Enabled:
					return 0;
				case Vgr.enumerations.userAccess.Disabled:
					return 1;
				default:
					return 2;
			}
		}

		function _mostRestrictive(access, other) {
			return _restrictiveness(access) >= _restrictiveness(other) ? access : other;
		}

		function _mostPermissive(access, other) {
			return _restrictiveness(access) <= _restrictiveness(other) ? access : other;
		}

		return {
			organizationHasAccessToState: _organizationHasAccessToState,
			applyAccess: _applyAccess
		};
	}
]);
